/**
 * URLs of the storefront-facing store read and coupon check
 * (api/src/endpoints/storefront_store.py).
 *
 * The storefront reads its store here, never through the store editor's
 * `/campaign/getCampaignById`: that loader is tenant checked (a back-office
 * user on another distributor's storefront got 403) and carries the editor
 * payload, which a shopper must not see.
 */

/** `GET` -- the store as shopper surfaces need it. */
export function storefrontStoreUrl(storeId) {
  return `/storefront/stores/${storeId}`;
}

/** `POST {code}` -- what ONE coupon code gets the shopper on this store. */
export function storefrontCouponUrl(storeId) {
  return `/storefront/stores/${storeId}/coupon`;
}

/** `POST {email}` -- mail a one-time verification code (email-gated stores). */
export function storefrontEmailCodeSendUrl(storeId) {
  return `/storefront/stores/${storeId}/email-code/send`;
}

/** `POST {email, code}` -- verify the code; records the email gate pass. */
export function storefrontEmailCodeVerifyUrl(storeId) {
  return `/storefront/stores/${storeId}/email-code/verify`;
}

/** `GET` -- `{password, email}`: the gate passes this session holds. */
export function storefrontGatePassUrl(storeId) {
  return `/storefront/stores/${storeId}/gate-pass`;
}

/** `POST {pin}` -- verify the store's Net Checkout PIN; mints the net pass. */
export function storefrontNetPinVerifyUrl(storeId) {
  return `/storefront/stores/${storeId}/net-pin/verify`;
}

/**
 * `GET` -- `{held, expires_at, terms_version, terms_text}`: whether this
 * session holds a net pass, and the CURRENT shopper Net Checkout terms.
 */
export function storefrontNetPassUrl(storeId) {
  return `/storefront/stores/${storeId}/net-pass`;
}
